<!-- Project: GSSC Pilot Front-end -->
<!-- Filename: Asset.vue -->
<!-- Copyright European Space Agency, 2020 -->
<!-- This file is part of the source code package for contract PO 5001024866 -->
<!-- No part of the package, including this file, may be copied, modified,      -->
<!-- propagated, or distributed without prior approval by ESA.                  -->
<template>
  <div class="asset card theme-shadow">
    <div class="card-header" :class="clsHeader">
      <div class="d-flex">
        <!-- <div v-if="data.resource_type.picture && data.resource_type.picture != 'None'">
          <img width="25" height="25" :src="data.resource_type.picture" alt="" />
        </div> -->
        <!-- <div class="flex-grow-1">
          <h4 class="card-title text-center" :class="clsTitle">{{ class_aux }}</h4>
        </div>-->
        <div class="flex-grow-1">
          <h5 class="card-title text-center" :class="clsTitle">{{ data.filename }}</h5>
        </div>

        <div title="Select asset" class="asset__checkbox custom-control custom-checkbox">
          <input
            type="checkbox"
            class="custom-control-input"
            :id="selectId"
            :checked="value"
            @input="emitSelection"
          />
          <label class="custom-control-label" :for="selectId"></label>
        </div>
      </div>
    </div>
    <div class="card-body" :style="iconBackground">
      <p>
        <span class="text-secondary">Collection:&nbsp;</span>
        <span>{{ name }} ({{ desc }})</span>
        <br />
        <span class="text-secondary">Resource Type:&nbsp;</span>
        <span>{{ resource_type }}</span>
        <br />
        <span class="text-secondary">File Path:&nbsp;</span>
        <span>{{ data.path }}</span>
        <br />
        <span v-if="file_format">
          <span class="text-secondary">File Format:&nbsp;</span>
          <span>{{ file_format }}</span>
          <br />
        </span>
        <!-- <span class="text-secondary">Generation Date:&nbsp;</span>
        <span>{{ generation_date }}</span>
        <br /> -->
        <span class="text-secondary">Generation Time:&nbsp;</span>
        <span>{{ generation_time }}</span>
        <br />
        <span v-if="resource_type !== 'Datalab'">
          <span class="text-secondary">Ingestion Time:&nbsp;</span>
          <span>{{ ingestion_time }}</span>
          <br />
        </span>
        <span v-if="doi && applicable(doi)">
          <span class="text-secondary">DOI:&nbsp;</span>
          <span>{{ doi }}</span>
        </span>
        <!-- <span class="text-secondary">License:&nbsp;</span>
        <a v-if="license.url" :href="license.url" target="_blank">{{ license.text }}</a>
        <span v-else>{{ license.text }}</span> -->
        <!-- <span>{{ helpers.license(data.collection.license) }}</span> -->
      </p>
    </div>
    <div class="card-footer">
      <p class="mb-0" asset__tags>
        <strong class="text-primary">Tags:&nbsp;</strong>
        <span
          v-for="tag in tags"
          :key="tag"
          class="badge badge-primary ml-1"
          v-if="tag != 'Not Available'"
          >{{ tag }}</span
        >
      </p>
      <div class="asset__actions">
        <!-- <button
          type="button"
          class="asset__actions-download btn btn-sm"
          @click.prevent="download"
          :class="clsOngoingDownload"
          :disabled="ongoingDownload"
        >
          <i class="icon icon-download bold-me"></i>
        </button> -->
        <button
          title="More"
          type="button"
          class="asset__actions-view btn btn-sm"
          @click.prevent="emitOpenModal"
        >
          <i class="icon icon-dots-three-horizontal"></i>
        </button>
        <div class="d-inline-block">
          <!-- <button
            v-if="auth && isUser"
            class="asset__actions-lab btn btn-sm"
            @click.prevent="emitAssetLabModal()"
            :disabled="noLab"
          >
            <i class="icon icon-lab"></i>
          </button> -->
          <!-- <button
              type="button"
              v-if="auth && isUser"
              class="asset__actions-lab btn btn-light btn-sm"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="icon icon-lab bold-me"></i>
          </button>-->
          <!-- <div class="dropdown-menu">
              <a
                class="dropdown-item"
                href="#"
                v-for="lab in data.asset_labs"
                :key="lab.name"
                @click.prevent="emitAssetLabModal(lab.name)"
                >{{ lab.name }}</a
              >
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import createComponent from '@/models/asset_component'
import helpers from '@/lib/helpers'

const component = createComponent()
export default component
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '~@/styles/globals';

.asset__actions {
  display: flex;

  .icon {
    padding: 0;
  }
}

.asset.card {
  word-break: break-all;
  border-radius: $border-radius;
  overflow: hidden;

  // border-top: 8px solid $main;
  .card-header {
    background-color: $primary;
    color: $neutral-space;
    font-weight: bold;
  }

  .card-footer {
    background-color: $neutral-space;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .asset__actions {
      button {
        color: $primary;

        &:hover {
          color: $main;
        }
      }
    }
  }

  // .card-header {
  //   // border-bottom: 8px solid #fff;
  //   &.selected-border-bottom {
  //     border-bottom: 8px solid $main;
  //   }
  // }
}

h5.card-title {
  margin-bottom: 0 !important;
}
</style>
